import {
  MasonryEngineActionHandler,
  MasonryEngineNodeAction,
} from '@leagueplatform/masonry-engine';
import { MasonryDriverAction } from '@leagueplatform/masonry-renderers';

type BenefitsFormSubmitAndToggleNodesAction = MasonryEngineNodeAction<
  'formSubmitAndToggleNodes',
  {
    formId: string;
    formProcessorId: string;
    onSuccessToggleNodeIds: string[];
    onErrorToggleNodeIds?: string[];
  }
>;

type BenefitsFormSubmitAndToggleNodesActionHandler = MasonryEngineActionHandler<
  BenefitsFormSubmitAndToggleNodesAction,
  MasonryDriverAction
>;

/**
 * Submits a Masonry form and then toggles node visibility based on the result.
 *
 * - On success: toggles `onSuccessToggleNodeIds`.
 * - On error: toggles `onErrorToggleNodeIds` (when provided); otherwise throws.
 */
export const formSubmitAndToggleNodesActionHandler: BenefitsFormSubmitAndToggleNodesActionHandler =
  async ({ payload, ancestry, event }, { invokeAction }) => {
    const {
      onSuccessToggleNodeIds,
      onErrorToggleNodeIds,
      ...submitFormPayload
    } = payload;

    const submitResult = await invokeAction({
      type: 'submitForm',
      namespace: 'default',
      payload: submitFormPayload,
      ancestry,
      event,
    });

    if (!submitResult?.isSuccess) {
      if (onErrorToggleNodeIds?.length) {
        await invokeAction({
          type: 'toggleVisibility',
          namespace: 'default',
          payload: { nodeIds: onErrorToggleNodeIds },
          ancestry,
          event,
        });
      } else {
        throw new Error(
          (typeof submitResult?.error === 'string'
            ? submitResult.error
            : null) || 'Form submission failed',
        );
      }

      return;
    }

    await invokeAction({
      type: 'toggleVisibility',
      namespace: 'default',
      payload: { nodeIds: onSuccessToggleNodeIds },
      ancestry,
      event,
    });
  };
